import { useDeliveryContext } from '_/contexts/DeliveryContext';
import FlowInfo from '_/features/flows/common/components/FlowInfo/FlowInfo';
import useFlowOpen from '_/features/flows/common/hooks/useFlowOpen';
import { IFlow, IFlowDelivery } from '_/features/flows/common/types/flow.types';
import { IDelivery } from '_/types/deliveries/delivery.types';
import Collapse from 'antd/lib/collapse';
import Tooltip from 'antd/lib/tooltip';
import Text from 'antd/lib/typography/Text';
import React, { ReactElement, useMemo } from 'react';

import classes from './DeliverySummaryFlowInfo.module.css';

const emptyDelivery = {
  flow: {
    name: '',
  },
  lastEditor: '',
};

const DeliverySummaryFlowInfo = (): ReactElement => {
  const { selectedDelivery: delivery } = useDeliveryContext();
  const { flow, flowDelivery, initiator } = (delivery || emptyDelivery) as IDelivery;
  const username = initiator?.email || initiator?.username;
  const { name: flowName } = flow as IFlow;
  const { flowDefinition } = (flowDelivery || {}) as IFlowDelivery;

  const openFlow = useFlowOpen();

  const items = useMemo(
    () => [
      {
        key: '1',
        label: (
          <div className="wb-flexbox wb-justifyContent_between">
            <Text className={classes.title} type="secondary">
              Flow Configuration
            </Text>
            <span>
              <Text className={classes.titleWithMargin} type="secondary">
                Initiated by:
              </Text>
              <Text>{username}</Text>
              <Text className={classes.titleWithMargin} type="secondary">
                Flow:
              </Text>
              <Tooltip title="Click to open the Flow">
                <span className={classes.link} onClick={openFlow}>
                  <Text>{flowName}</Text>
                </span>
              </Tooltip>
            </span>
          </div>
        ),
        children: <FlowInfo flow={flow as IFlow} flowConfig={flowDelivery} flowDefinition={flowDefinition} />,
      },
    ],
    [flowName, openFlow, username, flow, flowDelivery, flowDefinition],
  );

  return delivery ? <Collapse className="wb-flexbox wb-flexColumn" items={items} /> : <></>;
};

export default DeliverySummaryFlowInfo;
